import { ProductConfig } from "@core/interface/environment.interface";
import { ProductEnum } from "../product.enum";

export const majetokEnvironment: ProductConfig = {
    baseUrl: "",
    schemaEndpoint: "./api/v1/property-damage",
    productUrl: ProductEnum.MAJETOK,
    skipSteps: [
        {
            skipStepName: 'damaged-objects',
            conditions: [{
                stepName: 'damage-cause',
                param: 'damageCause',
                values: ['8']
            }]
        },
        {
            skipStepName: 'responsibility',
            conditions: [
                {
                    stepName: 'damage-data',
                    param: 'otherPropertyDamaged',
                    values: ['2'],
                    dependency: {
                        skipStepName: 'responsibility',
                        conditions: [
                            {
                                stepName: 'damage-cause',
                                param: 'damageCause',
                                values: ['1'],
                                negotiate: true
                            }
                        ]
                    }
                }
            ]
        }
    ],
    maxSingleFileSizeUpload: null,
    maxBulkFilesSizeUpload: 21000000, //
    deployUrl: ProductEnum.MAJETOK + '/'
};